// exclude-from-index
import React from 'react';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { TextInput } from '../TextInput';

function PhoneNumber(props) {
  /**
   * We have to manually pass a few props directly to the wrapped TextInput component
   * This is due to how react-input-mask handles passthrough props on the child
   * render function.
   * See: https://github.com/sanniassin/react-input-mask#children--function
   */
  const { disabled, readOnly, errorText, helperText, label, labelText, name, value, onBlur, onChange, error } = props;

  /**
   * Bug 23859: react-input-mask doesn't check if child components props are taken from defaultProps. TextInput was updated to (23469)
   * set defaultProp of onFocus to a no-op (() => {}). The Parent (InputMask) and Children (TextInput) props must be in sync, so an
   * identity stable no-op must be defined and passed to both components to prevent react-input-mask from throwing a fatal error.
   * See: https://github.com/sanniassin/react-input-mask/issues/139#issuecomment-423840451
   */
  const onFocusNoop = () => {};

  return (
    /**
     * maskChar needs to be a space. Why? I don't know but there is an open issue on
     * GitHub acknowledging that setting maskChar to null or "" causes autofill to strip
     * the first character off the string being autofilled.
     * This fixes it.
     * See: https://github.com/sanniassin/react-input-mask/issues/161
     */
    <InputMask
      disabled={disabled}
      readOnly={readOnly}
      errorText={errorText}
      helperText={helperText}
      label={label}
      labelText={labelText}
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      error={error}
      maskChar=" "
      mask="1 (999) 999-9999"
      onFocus={onFocusNoop}
    >
      {() => (
        <TextInput
          disabled={disabled}
          readOnly={readOnly}
          type="tel"
          errorText={errorText}
          helperText={helperText}
          label={label}
          labelText={labelText}
          name={name}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          error={error}
          onFocus={onFocusNoop}
        />
      )}
    </InputMask>
  );
}

PhoneNumber.propTypes = {
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  errorText: PropTypes.string,
  helperText: PropTypes.string,
  label: PropTypes.string,
  labelText: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  error: PropTypes.bool
};

PhoneNumber.defaultProps = {
  disabled: false,
  readOnly: false,
  errorText: '',
  helperText: '',
  label: '',
  labelText: '',
  name: '',
  value: '',
  onBlur: () => {},
  onChange: () => {},
  error: false
};

export default PhoneNumber;
